import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react';
import { useKBStore } from '@/stores/kbStore';

export default function KBWidget() {
  const { t } = useTranslation();
  const { isOpen, toggleOpen } = useKBStore();

  if (isOpen) return null;

  return (
    <button
      type="button"
      className="fixed bottom-6 right-6 z-[70] h-14 w-14 rounded-full bg-gradient-orange text-black shadow-glow-orange hover-glow flex items-center justify-center transition-transform hover:scale-105"
      onClick={toggleOpen}
      aria-label={t('kb.toggle')}
    >
      <BookOpen className="h-6 w-6" />
    </button>
  );
}
